export const getBaseURL = () => {
  return process.env.NEXT_PUBLIC_BASE_URL || "https://localhost:8000"
}

export const DEFAULT_REGION = process.env.NEXT_PUBLIC_DEFAULT_REGION || "ru"

/**
 * Store name. Rendered as the wordmark in the header, footer and checkout, and
 * emitted as schema.org `brand`/`seller` and the llms.txt heading. It is a
 * brand string rather than copy, so it is deliberately not translated in
 * `messages/*.json`.
 */
export const SITE_NAME =
  process.env.NEXT_PUBLIC_SITE_NAME || "DayZ PBO Protector"

/**
 * Handle of the SaaS product in Medusa whose PRO variants carry the live
 * monthly/yearly prices rendered on the pricing and landing pages.
 */
export const PRODUCT_HANDLE =
  process.env.NEXT_PUBLIC_PRODUCT_HANDLE || "my-pbo-tool"

/**
 * Destination of the "Download free" calls to action.
 *
 * Defaults to the download page itself, which lists the self-hosted mirror
 * first and then the Gitee / GitLab mirrors. Pointing the button at a single
 * platform is what broke it once already: when the GitHub account was suspended
 * on 2026-10-20, every asset turned 404 and the button became a dead link.
 * GitHub was dropped for good on 2026-10-24 (the desktop updater no longer
 * knows about it either). `NEXT_PUBLIC_DOWNLOAD_URL` still overrides it — a
 * mirror, a staging build, or a temporary rollback.
 */
export const DOWNLOAD_URL =
  process.env.NEXT_PUBLIC_DOWNLOAD_URL || "/download"

/**
 * Ticket 09 download block: version label + the two installer destinations.
 * FREE falls back to NEXT_PUBLIC_DOWNLOAD_URL and then to the release-page
 * default, so it is never empty. PRO has no public address yet: unset renders
 * a disabled "coming soon" state — never a fabricated URL.
 */
export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || ""
export const DOWNLOAD_FREE_URL =
  process.env.NEXT_PUBLIC_DOWNLOAD_FREE_URL || DOWNLOAD_URL || ""
export const DOWNLOAD_PRO_URL = process.env.NEXT_PUBLIC_DOWNLOAD_PRO_URL || ""

/**
 * GA4 measurement ID. Analytics is skipped entirely when it is unset, which is
 * the case in local development unless a developer opts in.
 */
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID

/**
 * Origin of the Better Auth identity server.
 *
 * 2026-10-30（阶段 6 · 身份搬家）：身份服务已经就在本站（`/api/auth/*`，由
 * payload-better-auth 挂在 `(payload)` 路由下），所以浏览器侧一律走同源相对
 * 路径。这个常量留给需要**绝对地址**的服务端场景（邮件链接、回跳）作默认值 ——
 * 它**不能**再回退到老站后端：老站正在下线，一旦有遗留调用就会指向一个
 * 即将停掉的服务。
 */
export const BETTER_AUTH_URL = (
  process.env.NEXT_PUBLIC_BETTER_AUTH_URL ||
  process.env.NEXT_PUBLIC_BASE_URL ||
  "http://localhost:8000"
).replace(/\/+$/, "")

/**
 * T13 (2026-10-02 walkthrough): the Discord gate's invite link. Optional — the
 * gate copy renders without it, so a deployment that has not created an invite
 * still tells the customer what to do.
 */
export const DISCORD_INVITE_URL = process.env.NEXT_PUBLIC_DISCORD_INVITE_URL || ""

